
function focus_the_game() {
	window.focus();
}

function get_game_size() {

	return {
		width: 64,
		height: 64
	};

}

function set_game_size() {
	var size = get_game_size();
	game.scale.setGameSize( size.width, size.height );
}

var Game = {

	// Game Properties.
	name: 'Star Raid',
	debug: false,
	background_color: '#006d99',
	desiredFps: false,

	//
	font_set: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789.,;:?!-_\'#"\\/<>()@',
	game_state: 'play',

	// Code collections.
	States: {},
	Prefabs: {},
	Utils: {},
	Plugins: {},
	JSON: {},

};



Array.prototype.unique = function() {

	var a = this.concat();

	for ( var i = 0; i < a.length; i++ ) {

		for ( var j = i + 1; j < a.length; j++ ) {

			if ( a[i] === a[j] ) {

				a.splice( j--, 1 );

			}

		}

	}

    return a;

};
/**
 * Audio library
 *
 * Load and manage audio data from a single place. Allows for simpler reuse
 * across different game states.
 *
 * @type {Object}
 */
Game.Utils.Audio = {

	// Store the audio info.
	audio: [],


	/**
	 * Initialise the audio data.
	 *
	 * Ensures all of the game audio is assigned to a variable to be used.
	 * Also sets base audio properties (like default volumes).
	 */
	init: function() {

		// Don't reinitialize audio effects if they have already been set.
		if ( this.audio.length > 0 ) {
			return;
		}

		// Load all the things!
		// They get put in the audio array for easy access in the other functions.
		// The array is public so can also be accessed directly through: Game.Utils.Audio.audio['key']
		this.audio[ 'wind' ] = game.add.audio( 'wind' );
		this.audio[ 'menu' ] = game.add.audio( 'menu' );
		this.audio[ 'theme' ] = game.add.audio( 'theme' );
		this.audio[ 'splash' ] = game.add.audio( 'splash' );
		this.audio[ 'turn' ] = game.add.audio( 'ski-turn' );
		this.audio[ 'win' ] = game.add.audio( 'win' );
		this.audio[ 'lose' ] = game.add.audio( 'lose' );
		this.audio[ 'countdown' ] = game.add.audio( 'countdown' );

		this.audio[ 'weeeee' ] = game.add.audio( 'weeeeee' );
		this.audio[ 'weeeee' ].volume = 0.8;

		this.audio[ 'jump' ] = game.add.audio( 'jump-land' );
		this.audio[ 'jump' ].volume = 1.5;

		this.audio[ 'crash' ] = game.add.audio( 'crash' );
		this.audio[ 'crash' ].volume = 1.5;

	},


	/**
	 * Play the specified audio effect on a loop.
	 *
	 * @param  {string} effect The key for the audio effect to loop.
	 */
	play_loop: function( effect ) {

		return;

		if ( Game.debug ) {
			console.log( 'Audio loop: ' + effect );
		}

		this.audio[ effect ].loopFull();

	},


	/**
	 * Play a sound effect.
	 *
	 * @param  {string} audio The key for the audio effect to play.
	 */
	play: function( audio ) {

		return;

		this.audio[ audio ].play();

	},


	/**
	 * Fade out a sound effect.
	 *
	 * @param  {string} audio The key for the audio effect to fade out.
	 */
	fade_out: function( audio ) {

		return;

		this.audio[ audio ].fadeOut();

	},


	/**
	 * Fade in a sound effect.
	 *
	 * @param  {string}  audio    The key for the effect to fade in.
	 * @param  {Number}  duration The duration of the fade.
	 * @param  {Boolean} loop     Whether the effect should loop after fading in. Defaults to looping.
	 */
	fade_in: function( audio, duration, loop ) {

		return;

		if ( ! duration ) {
			duration = 1000;
		}

		if ( ! loop ) {
			loop = true;
		}

		this.audio[ audio ].fadeIn( duration, loop );

	},

}

/**
 * Camera functionality, including the smooth camera position, and ensuring the
 * camera only sits on round pixel values to keep things nice and crisp.
 *
 * @type {Object}
 */
Game.Utils.Camera = {


	// get x() {
	// 	return game.camera.x;
	// },
	//
	// set x( value ) {
	// 	game.camera.x = value;
	// },
	//
	//

	/**
	 * Initialize the camera properties that will be reused throughout the game.
	 */
	init: function() {

	},


	/**
	 * Set the target for the camera to follow.
	 *
	 * @param  {Skier} target The skier to follow.
	 */
	set_target: function( target ) {

		game.camera.follow( target );

		var w = Math.round( game.height / 16 );
		var h = Math.round( game.height / 5.333 );
		game.camera.deadzone = new Phaser.Rectangle(
			Math.round( ( game.width - w ) / 2 ),
			Math.round( ( game.height - h ) / 2 + h * 0.3 ),
			w,
			h
		);

		console.log( game.camera.deadzone );

	},


};

Game.Utils.Controls = {

	cursor: null,
	action: null,

	init: function() {

		// Controls.
		this.cursor = game.input.keyboard.createCursorKeys();
		this.action = game.input.keyboard.addKey( Phaser.Keyboard.SPACEBAR );

	},

};

Game.Utils.callbacks = {

	exitLevel: function( zone ) {

		if ( Game.Utils.Hud.coins.getValue() >= 200 ) {

			if ( 'open' === zone.door.state ) {
				return;
			}

			zone.door.open();

			Game.Utils.ManageDoors.unlockDoor( zone.name );

		}

	},

};
Game.Utils.Hud = {


	coins: null,

	init: function( layers ) {

		this.coins = new Game.Prefabs.HudCounter( game, layers.groupHud );
		this.coins.setText( '000' );

	},


	addCoin: function() {

		var coinCount = ( this.coins.getValue() + 1 ).toString();
		coinCount = coinCount.padStart( 3, 0 );
		this.coins.setText( coinCount );

	},

};
Game.Utils.Inventory = {

	db: [],

	init: function() {

		this.load();

	},

	collect: function( key, value ) {

		if ( ! value ) {
			value = true;
		}

		this.db[ key ] = value;

		this.save();

	},

	haveItem: function( key ) {

		if ( 'undefined' !== typeof this.db[key] ) {
			return true;
		}

		return false;

	},

	save: function() {

		// console.table( this.db );

	},

	load: function() {

		this.db = [];

	},

};

Game.Utils.Layers = {

	layers: {},

	init: function() {

		// Generate layers.
		this.layers = {
			groupLevelBottom: game.add.group(),
			groupElements: game.add.group(),
			groupLevelTop: game.add.group(),
			groupHud: game.add.group(),
			groupModal: game.add.group(),
		};

		// fix hud to camera,
		// Hud includes game based interfaces. Buttons, scores etc
		// This can be covered by modal elements.
		this.layers.groupHud.fixedToCamera = true;

		// Fix modal elements to camera.
		this.layers.groupModal.fixedToCamera = true;

		// Return layers.
		return this.layers;

	},

};

/**
 * Manage Coins.
 *
 * This creates, and updates the coins throughout the world.
 * @type {Object}
 */
Game.Utils.ManageCoins = {

	coins: [],

	coins_total: 0,

	SIZE: 8,

	/**
	 * Initialize the coin manager.
	 *
	 * @param  {Object} map_layer The Tiled layer used to store map properties.
	 * @param  {[type]} tile_id   The texture id for the tile used to display coins.
	 * @param  {[type]} layer     The layer to add the coins to.
	 */
	init: function( map_layer, tile_id, layer ) {

		this.reset();

		// Get the 2-dimensional tiles array for this layer.
		var d = map_layer.map.layers[map_layer.index].data;

		for ( var i = 0; i < d.length; i++ ) {

			for ( var j = 0; j < d[i].length; j++ ) {

				var t = d[i][j];

				if ( tile_id === t.index ) {

					var x = j * Game.Utils.Map.TILE_SIZE;
					var y = i * Game.Utils.Map.TILE_SIZE;

					var coin = new Game.Prefabs.Coin( game, x, y, layer );

					this.coins.push( coin );

				}

			}

		}

		this.coins_total = this.coins.length;

		console.log( 'Total coins', this.coins.length );

	},


	/**
	 * Check the coins to see if the player is overlapping it.
	 *
	 * @param  {[type]} player [description]
	 * @return {[type]}        [description]
	 */
	update: function( player ) {

		// If player is disabled for some reason then don't check coins.
		if ( ! player.alive ) {
			return;
		}

		for ( var c = 0; c < this.coins.length; c++ ) {

			var coin = this.coins[c];

			if ( player.x > coin.x - this.SIZE && player.x < coin.x + this.SIZE ) {
				if ( player.body.bottom > coin.y && player.body.top < coin.y ) {

					coin.collect();
					this.coins.splice( c, 1 );

					Game.Utils.Hud.addCoin();

					Game.Utils.Inventory.collect( this.getKey( coin ) );
					Game.Utils.Inventory.collect( 'coin/count', Game.Utils.Hud.coins.getValue() );

				}
			}

		}

	},


	lotsOfCoins: function() {

		for( var i = 0; i < 300; i ++ ) {

			Game.Utils.Hud.addCoin();

		};

	},


	getKey: function( coin ) {

		return 'coin/world-1/' + Game.Utils.Map.tile_coord( coin.x ) + ':' + Game.Utils.Map.tile_coord( coin.y );

	},


	getTotal: function() {

		return this.coins_total;

	},


	getRemaining: function() {

		return this.coins.length;

	},


	/**
	 * Reset existing coins and delete the instances.
	 *
	 * @return {[type]} [description]
	 */
	reset: function() {

		for ( var c = 0; c < this.coins.length; c++ ) {

			var coin = this.coins[c];
			coin.kill();

		}

		this.coins = [];

		this.coins_total = 0;

	},

};

/**
 * Manage Coins.
 *
 * This creates, and updates the coins throughout the world.
 * @type {Object}
 */
Game.Utils.ManageComputers = {

	computers: [],

	tempName: '',

	/**
	 * Initialize the coin manager.
	 *
	 * @param  {Object} map_layer The Tiled layer used to store map properties.
	 * @param  {[type]} tile_id   The texture id for the tile used to display coins.
	 * @param  {[type]} layer     The layer to add the coins to.
	 */
	init: function( layer ) {

		this.reset();

		var computers = Game.Utils.Map.find_objects_by_type( 'computer', Game.Utils.Map.map, 'objects' );

		computers.forEach(
			function( computer ) {

				computer.y -= Game.Utils.Map.TILE_SIZE;

				var newComputer = new Game.Prefabs.Computer( game, computer.x, computer.y, layer, computer );
				Game.Utils.ManageComputers.computers.push( newComputer );

			}
		);

	},


	/**
	 * Reset existing coins and delete the instances.
	 *
	 * @return {[type]} [description]
	 */
	reset: function() {

		for ( var c = 0; c < this.computers.length; c++ ) {

			var computer = this.computers[c];
			computer.kill();

		}

		this.keys = [];

	},

};

/**
 * Manage Coins.
 *
 * This creates, and updates the coins throughout the world.
 * @type {Object}
 */
Game.Utils.ManageDoors = {

	doors: [],

	tempName: '',

	/**
	 * Initialize the coin manager.
	 *
	 * @param  {Object} map_layer The Tiled layer used to store map properties.
	 * @param  {[type]} tile_id   The texture id for the tile used to display coins.
	 * @param  {[type]} layer     The layer to add the coins to.
	 */
	init: function( type, layer ) {

		var doors = Game.Utils.Map.find_objects_by_type( type, Game.Utils.Map.map, 'objects' );

		doors.forEach(
			function( door ) {

				door.y -= Game.Utils.Map.TILE_SIZE;

				var newDoor = new Game.Prefabs.Door( game, door.x, door.y, type, layer, door );
				Game.Utils.ManageDoors.doors.push( newDoor );

			}
		);

	},


	getKey: function( door ) {

		return 'door/world-1/' + Game.Utils.Map.tile_coord( door.x ) + ':' + Game.Utils.Map.tile_coord( door.y );

	},


	unlockDoor: function( name ) {

		this.tempName = name;

		this.doors.forEach(
			function( door ) {

				if ( door.name === Game.Utils.ManageDoors.tempName ) {

					door.doorTiles.forEach(
						function( tile ) {

							Game.Utils.Map.set_tile_collision( tile[0], tile[1], [ 0, 0, 0, 0 ], -1 );

						}
					);

				}

			}
		);

		this.tempName = '';

	},


	/**
	 * Reset existing coins and delete the instances.
	 *
	 * @return {[type]} [description]
	 */
	reset: function() {

		for ( var d = 0; d < this.doors.length; d++ ) {

			var door = this.doors[d];
			door.kill();

		}

		this.keys = [];

	},

};

/**
 * Manage Coins.
 *
 * This creates, and updates the coins throughout the world.
 * @type {Object}
 */
Game.Utils.ManageKeys = {

	keys: [],

	SIZE: 10,

	/**
	 * Initialize the key manager.
	 *
	 * @param  {Object} map_layer The Tiled layer used to store map properties.
	 * @param  {[type]} tile_id   The texture id for the tile used to display coins.
	 * @param  {[type]} layer     The layer to add the coins to.
	 */
	init: function( layer ) {

		this.reset();

		var keys = Game.Utils.Map.find_objects_by_type( 'key', Game.Utils.Map.map, 'objects' );

		keys.forEach(
			function( key ) {

				key.y -= Game.Utils.Map.TILE_SIZE;

				var newKey = new Game.Prefabs.Key( game, key.x, key.y, layer, key );
				Game.Utils.ManageKeys.keys.push( newKey );

			}
		);

	},


	/**
	 * Check the coins to see if the player is overlapping it.
	 *
	 * @param  {[type]} player [description]
	 * @return {[type]}        [description]
	 */
	update: function( player ) {

		// If player is disabled for some reason then don't check coins.
		if ( !player.alive ) {
			return;
		}

		for ( var k = 0; k < this.keys.length; k++ ) {

			var key = this.keys[ k ];

			if ( player.x > key.x - this.SIZE && player.x < key.x + this.SIZE ) {
				if ( player.y > key.y - this.SIZE && player.y < key.y + this.SIZE + this.SIZE ) {

					key.collect();
					this.keys.splice( k, 1 );

					Game.Utils.Inventory.collect( this.getKey( key ) );
					Game.Utils.Inventory.collect( 'key/' + key.keyProperties.name );
					// Game.Utils.Inventory.collect( 'coin/count', Game.Utils.Hud.coins.getValue() );

				}
			}

		}

	},


	getKey: function( key ) {

		return 'key/world-1/' + Game.Utils.Map.tile_coord( key.x ) + ':' + Game.Utils.Map.tile_coord( key.y );

	},


	/**
	 * Reset existing coins and delete the instances.
	 *
	 * @return {[type]} [description]
	 */
	reset: function() {

		for ( var k = 0; k < this.keys.length; k++ ) {

			var key = this.keys[ k ];
			key.kill();

		}

		this.keys = [];

	},

};

Game.Utils.ManagePlatforms = {

	platforms: [],

	locked: false,
	lockedTo: false,

	init: function( layer ) {

		var paths = Game.Utils.Map.find_objects_by_type( 'path', Game.Utils.Map.map, 'objects' );

		paths.forEach(
			function( path ) {

				var platform = new Game.Prefabs.Platform( game, path, layer );

				Game.Utils.ManagePlatforms.platforms.push( platform );

			}
		);

	},


	collision_callback: function( player, platform ) {

		if ( ! Game.Utils.ManagePlatforms.locked && player.body.velocity.y > 0 ) {

			player.body.velocity.y = 0;
			player.locked = true;
			player.lockedTo = platform;

			player.state = Game.Prefabs.Man.states.WALK;

		}

	},


	update: function( man ) {

		if ( man.locked ) {
			this.checkLock( man );
		}

	},


	pre_render: function( man ) {

		//  Because preRender still runs even if your game pauses!
		if ( game.paused ) {
			return;
		}

		if ( man.locked ) {

			man.x += man.lockedTo.deltaX;
			man.y = man.lockedTo.y;

			man.body.velocity.y = 0;

		}

		this.platforms.forEach(
			function( platform ) {

				platform.preRender( man );

			}
		);

	},

	checkLock: function( man ) {

		if ( ! man.locked ) {
			return;
		}

		// If the player has walked off the edge of the platform.
		if ( man.body.right < man.lockedTo.left || man.body.left > man.lockedTo.right ) {
			this.cancelLock( man );
		}

	},

	cancelLock: function( man ) {

		man.locked = false;
		man.lockedTo = null;

	},

};
Game.Utils.ManageWorld = {

	init: function( layers ) {

		Game.Utils.ManageCoins.init( Game.Utils.Map.layer_properties, 3073 + 1, layers.groupElements );

		Game.Utils.ManageKeys.init( layers.groupElements );

		Game.Utils.ManageComputers.init( layers.groupElements );

		Game.Utils.ManagePlatforms.init( layers.groupElements );

		Game.Utils.ManageDoors.reset();
		Game.Utils.ManageDoors.init( 'door-horizontal', layers.groupElements );
		Game.Utils.ManageDoors.init( 'door-vertical', layers.groupElements );
		Game.Utils.ManageDoors.init( 'door', layers.groupElements );

	},

	update: function( player ) {

		Game.Utils.ManageCoins.update( player );
		Game.Utils.ManageKeys.update( player );
		Game.Utils.ManagePlatforms.update( player );
		Game.Utils.Signposts.update( player );

	},

	pre_render: function( player ) {

		Game.Utils.ManagePlatforms.pre_render( player );

	},

};


/**
 * Apply environmental properties to Skiiers.
 *
 * @type {Object}
 */
Game.Utils.MapEnvironment = {


	/**
	 * Execute the environment effects.
	 *
	 * @param  {Skier} skier The skier that will be affected by the environment.
	 */
	run: function( man ) {

		// Reset the players height.
		man.tile_height = 0;

		// Get the current tile data, and the tile id.
		var tile = Game.Utils.Map.get_tile( man.x, man.y, Game.Utils.Map.layer_properties );
		var tile_id = tile.index;

		// Quit if the tile has no interesting features.
		if ( tile_id <= 0 ) {
			return;
		}

		// Check for an action method for the current tile.
		if ( 'function' === typeof this[ 'overlap_' + tile_id ] ) {
			this[ 'overlap_' + tile_id ]( man, tile );
		}

	},


	/**
	 * Set the skier height.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_992: function( man ) {

		man.tile_height = 3;
		man.body.velocity.y += 0.3;

	},


	/**
	 * Set the skier height.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_991: function( man ) {

		man.tile_height = 2;
		man.body.velocity.y += 0.2;

	},


	/**
	 * Set the skier height.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_990: function( man ) {

		man.tile_height = 1;
		man.body.velocity.y += 0.1;

	},


	/**
	 * Water - drown.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_989: function( man, tile ) {

		var skier_size = 2;

		if ( ( man.y - skier_size ) > tile.worldY && ( man.y + skier_size ) < ( tile.worldY + Game.Utils.Map.TILE_SIZE ) ) {

			// Nest the checks so that we don't have to do them if the first is false.
			// Check left.
			if ( Game.Utils.Map.point_overlap_water( man.x - skier_size, man.y ) ) {

				// Check right.
				if ( Game.Utils.Map.point_overlap_water( man.x + skier_size, man.y ) ) {

					Game.Utils.Audio.play( 'splash' );
					man.death_drown();

				}

			}

		}

	},


	/**
	 * Ski faster.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_988: function( man ) {

		man.body.velocity.y += 1;

	},


	/**
	 * Weeeeee.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_987: function( man ) {

		man.body.velocity.y += 1.5;

		Game.Utils.Audio.play( 'weeeee' );

	},


	/**
	 * Disable the ski trail.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_986: function( man ) {

	},


	/**
	 * Ski super fast.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_985: function( man ) {

		man.body.velocity.y += 2;

	},


	/**
	 * Coin.
	 *
	 * @param  {Object} skier The skier to apply the environmental effect to.
	 */
	overlap_984: function( man ) {



	},

};

/**
 * Actions for the different zones.
 *
 * @type {Object}
 */
Game.Utils.MapZonesActions = {


	/**
	 * Set skier to walk mode.
	 *
	 * @param  {skier} skier The skier who should be walking.
	 * @param  {object} zone The zone data.
	 */
	walk: function( skier, zone ) {

		// If we're not skiing, ie we're jumping, then let's quit. We don't care
		// about walking in this case.
		if ( ! skier.alive ) {
			return;
		}

		if ( ! skier.is_skiing() ) {
			return;
		}

		skier.state = Game.Prefabs.Man.states.WALK;

	},


	/**
	 * Enter a door.
	 *
	 * @param  {skier} skier The skier who is entering the door.
	 * @param  {object} zone The zone data.
	 */
	door_old: function( skier, zone ) {

		var type = 'world';
		var path = 'world';
		var checkpoint = '';

		if ( Game.Utils.Map.zone_has_property( zone, 'room' ) ) {
			type = 'room';
			path = 'rooms/' + zone.properties.room;
		}

		if ( Game.Utils.Map.zone_has_property( zone, 'checkpoint' ) ) {
			checkpoint = zone.properties.checkpoint;
		}

		game.state.start(
			'load-world',
			true,
			false,
			{
				'path': path,
				'type': type,
				'checkpoint': checkpoint
			}
		);

	},


	door: function( player, zone ) {

		if ( zone.callback && undefined !== typeof Game.Utils.callbacks[zone.callback] ) {

			Game.Utils.callbacks[zone.callback]( zone );
			return;

		}

		if ( Game.Utils.Inventory.haveItem( 'key/' + zone.name ) ) {

			zone.door.open();

		}

	},


	/**
	 * Display a signpost message.
	 *
	 * @param  {skier} skier The skier who is reading the signpost.
	 * @param  {object} zone The zone data.
	 */
	computer: function( player, zone ) {

		if ( zone.name ) {

			var key = zone.name;

			if ( Game.JSON.signposts[ key ] ) {

				Game.Utils.Signposts.display( Game.JSON.signposts[ key ], zone );

			}

		}

	},


	/**
	 * Temporary time trial.
	 *
	 * @param  {skier} skier The skier.
	 * @param  {object} zone The zone data.
	 */
	timetrial: function( skier, zone ) {

		game.state.start(
			'time-trial'
		);

	},


};

/**
 * Perform actions related to the different world zones.
 *
 * @type {Object}
 */
Game.Utils.MapZones = {


	/**
	 * Check to see if the Skier is in an actionable zone and then perform
	 * appropriately.
	 *
	 * @param  {skier} skier The skier to check.
	 */
	check: function( skier ) {

		// Loop through all zones.
		for ( var key in Game.Utils.Map.zones ) {

			if ( ! Game.Utils.Map.zones.hasOwnProperty( key ) ) {
				continue;
			}

			// Store the current zone. Mostly for readability.
			var zone = Game.Utils.Map.zones[ key ];

			// If the skier is in the current zone then do something.
			if ( this.in_zone( skier, zone ) ) {

				// Check to see if the current zone type has an action, and if
				// so run the action.
				if ( 'function' === typeof Game.Utils.MapZonesActions[ zone.type ] ) {

					Game.Utils.MapZonesActions[ zone.type ]( skier, zone );

				}

			}

		}

	},


	/**
	 * Check if a skier is in a zone.
	 *
	 * @param  {Object} skier The skier to test against the zone.
	 * @param  {Object} zone  The zone to check against.
	 * @return {boolean}
	 */
	in_zone: function( skier, zone ) {

		// Ensure a zone is being passed in.
		if ( ! zone ) {
			return false;
		}

		// Offset the skier y position since by default it sits below the player
		// graphic.
		var y = skier.y - 4;
		var x = skier.x;

		if ( y > zone.y ) {
			if ( y < zone.y + zone.height ) {
				if ( x > zone.x ) {
					if ( x < zone.x + zone.width ) {

						return true;

					}
				}
			}
		}

		return false;

	}

};


/**
 * Map object
 * Load and setup tilemaps.
 * Includes all collision and interactin info.
 */
Game.Utils.Map = {

	// VARIABLES

	// Loaded map.
	map: null,

	// Different zones.
	zones: {},

	// Layers.
	layer: null,
	layer_details_top: null,
	layer_details_bottom: null,
	layer_collision: null,
	layer_properties: null,

	// Player Start Data
	player_position: {},

	// Standard regions
	// region_start: null,
	// region_finish: null,

	start_position: null,


	// CONSTANTS

	// Tile dimensions.
	TILE_SIZE: 8,
	TILE_HALF_SIZE: 4,

	// Tile id for left side only collision tile.
	LEFT_WALL: 11 + 3073,

	// Tile id for right side only collision tile.
	RIGHT_WALL: 12 + 3073,

	TOP_WALL: 10 + 3073,

	BOTTOM_WALL: 13 + 3073,

	// Number of pixels above the collision object you need to be in order to trigger a collision.
	TILE_COLLISION_OFFSET: -2,

	// Top collision tile.
	TILE_COLLISION: 8 + 3073,

	TILE_UNPASSABLE: 9 + 3073,

	// Water tile.
	TILE_WATER: 989,

	TILE_LADDER: 14 + 3073,


	load_room: function( map_name, layers, params ) {

		params.texture = 'rooms';

		this.load( map_name, layers, params );

	},


	load_world: function( map_name, layers, params ) {

		params.texture = 'world';

		this.load( map_name, layers, params );

	},

	/**
	 * Load level
	 */
	load: function( map_name, layers, params ) {

		// setup map
		this.map = game.add.tilemap( map_name );

		this.map.addTilesetImage( params.texture );
		this.map.addTilesetImage( 'collision' );

		this.map.setCollision( [ this.TILE_COLLISION ], true, 'collision' );

		// Add map layers.
		this.layer = this.map.createLayer( 'tiles' );
		layers.groupLevelBottom.add( this.layer );

		this.resize_world();

		// Details Top
		// These are drawn on top of the player.
		this.layer_details_top = this.map.createLayer( 'details_top' );
		layers.groupLevelTop.add( this.layer_details_top );

		// Details Bottom
		// These display under the player, and on top of the world map.
		this.layer_details_bottom = this.map.createLayer( 'details_bottom' );
		layers.groupLevelBottom.add( this.layer_details_bottom );

		this.layer_collision = this.map.createLayer( 'collision' );
		layers.groupLevelTop.add( this.layer_collision );

		this.layer_properties = this.map.createLayer( 'properties' );
		layers.groupLevelTop.add( this.layer_properties );

		// Hide debug layers if not in debug mode.
		if ( !Game.debug ) {

			this.layer_collision.visible = false;
			this.layer_properties.visible = false;

		}

		this.set_all_tile_collision();

		// position player
		var player_position = this.find_objects_by_type( 'start', this.map, 'objects' );

		if ( params.checkpoint ) {
			player_position = this.find_objects_by_name( params.checkpoint, this.map, 'objects' );
		}

		if ( player_position[ 0 ] ) {

			// use the first result - there should only be 1 start point per level
			// if there isn't we'll just ignore the others
			this.player_position.x = parseInt( player_position[ 0 ].x + this.TILE_HALF_SIZE );
			this.player_position.y = parseInt( player_position[ 0 ].y );

		}

		// Zones.
		this.zones = this.find_objects_by_type( '', this.map, 'zones' );

	},


	add_zone: function( properties ) {

		var defaultProperties = {
			height: Game.Utils.Map.TILE_SIZE,
			width: Game.Utils.Map.TILE_SIZE,
			name: '',
			rectangle: true,
			rotation: 0,
			type: '',
			visible: true,
			x: 0,
			y: 0,
		};

		var newProperties = Object.assign( defaultProperties, properties );

		// console.log( 'new zone', newProperties );

		this.zones.push( newProperties );

	},


	/**
	 * Find objects in a Tiled layer that have the type equal to a certain value.
	 *
	 * @param   {String}     type   The object type to find, as specified in the map file
	 * @param   {Object}     map    Tilemap bject
	 * @param   {String}     layer  Key for object layer to search
	 * @returns {Array}      List of objects
	 */
	find_objects_by_type: function( type, map, layer ) {

		var result = new Array();

		map.objects[ layer ].forEach(

			function( element ) {

				if ( '' !== type ) {

					if ( typeof element.type !== 'undefined' && element.type.toLowerCase() === type.toLowerCase() ) {

						result.push( element );

					}

				} else {

					result.push( element );

				}

			}

		);

		return result;

	},


	/**
	 * Find objects in a Tiled layer that have the name equal to a certain value.
	 *
	 * @param   {String}     name   The object type to find, as specified in the map file
	 * @param   {Object}     map    Tilemap bject
	 * @param   {String}     layer  Key for object layer to search
	 * @returns {Array}      List of objects
	 */
	find_objects_by_name: function( name, map, layer ) {

		var result = new Array();

		map.objects[ layer ].forEach(

			function( element ) {

				if ( '' !== name ) {

					if ( typeof element.name !== 'undefined' && element.name.toLowerCase() === name.toLowerCase() ) {

						result.push( element );

					}

				} else {

					result.push( element );

				}

			}

		);

		return result;

	},


	/**
	 * Set tile collision properties.
	 *
	 * Allows collisions on a single side of the tile.
	 *
	 * @param  {Object} 	mapLayer The map layer to scan.
	 * @param  {Int} 		id       The id of the tile to apply the collision to.
	 * @param  {directions} dirs     An object with the direction settings desired.
	 */
	set_all_tile_collision: function() {

		// top = 0
		// right = 1
		// bottom = 2
		// left = 3

		var collision = [];
		collision[ this.RIGHT_WALL ] = [ false, true, false, false ];
		collision[ this.LEFT_WALL ] = [ false, false, false, true ];
		collision[ this.BOTTOM_WALL ] = [ false, false, true, false ];
		collision[ this.TOP_WALL ] = [ true, false, false, false ];

		// get the 2-dimensional tiles array for this layer
		var d = this.layer_collision.map.layers[ this.layer_collision.index ].data;

		for ( var i = 0; i < d.length; i++ ) {

			for ( var j = 0; j < d[ i ].length; j++ ) {

				if ( collision[ d[ i ][ j ].index ] ) {

					this.set_tile_collision( j, i, collision[ d[ i ][ j ].index ] );

				}

			}

		}

	},


	set_tile_collision: function( x, y, collision, tile_index ) {

		var d = this.layer_collision.map.layers[ this.layer_collision.index ].data;

		var t = d[ y ][ x ];

		if ( !t ) {
			return;
		}

		if ( tile_index ) {
			t.index = tile_index;
		}

		t.collideUp = collision[ 0 ];
		t.collideDown = collision[ 2 ];
		t.collideLeft = collision[ 3 ];
		t.collideRight = collision[ 1 ];

		t.faceTop = collision[ 0 ];
		t.faceBottom = collision[ 2 ];
		t.faceLeft = collision[ 3 ];
		t.faceRight = collision[ 1 ];

	},


	add_tile_collision: function( tiles, tile_index, collision ) {

		for ( var i = 0; i < tiles.length; i++ ) {

			this.set_tile_collision( tiles[ i ][ 0 ], tiles[ i ][ 1 ], collision, tile_index );

		}

	},


	/**
	 * Resize the world so that it remains central to the camera viewport.
	 */
	resize_world: function() {

		// Use the main game tilemap since that will have the most tiles on it.
		var layer = this.layer.layer;

		// Work out how big the world should be.
		//
		// This uses the screen width to ensure the map is centered.
		// If the map width is less than the screen width then a bit of extra
		// space is added.
		var layer_width = Math.max( layer.widthInPixels, game.width ) * game.world.scale.x;
		var layer_height = Math.max( layer.heightInPixels, game.height ) * game.world.scale.y;

		// The map is offset slightly based on the size of the map against the
		// screen.
		//
		// This ensures the map isn't locked to the top left corner.
		var offset_x = 0;
		var offset_y = 0;

		if ( layer_width === game.width ) {
			offset_x = Math.floor( ( layer_width - layer.widthInPixels ) / -2 );
		}

		if ( layer_height === game.height ) {
			offset_y = Math.floor( ( layer_height - layer.heightInPixels ) / -2 );
		}

		game.world.setBounds( offset_x, offset_y, layer_width, layer_height );

	},


	/**
	 * Check to see if the current zone has the specified custom property.
	 *
	 * @param  {Object} zone     The object defining the property to check.
	 * @param  {string} property The property key to search for.
	 * @return {boolean}         [description]
	 */
	zone_has_property: function( zone, property ) {

		if ( 'undefined' !== typeof zone.properties && 'undefined' !== typeof zone.properties[ property ] ) {
			return true;
		}

		return false;

	},


	/**
	 * Does the x, y position overlap water.
	 *
	 * @param  {Int} x X coordinate to check.
	 * @param  {Int} y Y coordinate to check.
	 * @return {bool}
	 */
	point_overlap_water: function( x, y ) {

		return this.point_overlap( x, y, this.layer_properties, this.TILE_WATER );

	},


	/**
	 * Does the x, y position overlap a ladder.
	 *
	 * @param  {Int} x X coordinate to check.
	 * @param  {Int} y Y coordinate to check.
	 * @return {bool}
	 */
	point_overlap_ladder: function( x, y ) {

		return this.point_overlap( x, y, this.layer_properties, this.TILE_LADDER );

	},


	/**
	 * Does the x, y position collide with anything?
	 * Ignores side only tiles.
	 *
	 * @param  {Int} x X coordinate to check.
	 * @param  {Int} y Y coordinate to check.
	 * @return {bool}
	 */
	point_overlap_collision: function( x, y ) {

		return this.point_overlap( x, y, this.layer_collision, this.TILE_COLLISION );

	},


	/**
	 * Does the specified point overlap the specified tile type on the specified tile layer?
	 *
	 * @param  {Int} 	x          X pixel coordinate to check.
	 * @param  {Int} 	y          Y pixel coordinate to check.
	 * @param  {Object} tile_layer Tile layer to check against.
	 * @param  {Int} 	tile_index Tile index we are looking for.
	 * @return {bool}
	 */
	point_overlap: function( x, y, tile_layer, tile_index ) {

		// Make sure the tile index, and layer are set.
		if ( !tile_index || !tile_layer ) {
			return false;
		}

		var tile = this.get_tile( x, y, tile_layer );

		if ( !tile ) {
			return false;
		}

		// If the tile index is the desired tile type then return true.
		if ( tile.index && tile_index === tile.index ) {
			return true;
		}

		// If we got this far then it's not a match.
		return false;

	},


	/**
	 * Get the tile data for the tile at the specified x, y coordinate.
	 *
	 * @param  {Number} x          The x position of the tile.
	 * @param  {Number} y          The y position of the tile.
	 * @param  {Object} tile_layer The Game.Utils.Map tile layer object.
	 * @return {Object}
	 */
	get_tile: function( x, y, tile_layer ) {

		// Get tile at specified coordinates.
		var tiles = tile_layer.getTiles( x, y, 1, 1 );

		// No tiles found?
		if ( 0 === tiles.length ) {
			return false;
		}

		// Since we're checking for a point it will only be one tile.
		return tiles[ 0 ];

	},


	/**
	 * Convert a number into an absolute position.
	 *
	 * @param  {Number} pixel_position The position of the tile.
	 * @return {Number}
	 */
	tile_coord: function( pixel_position ) {

		return Math.floor( pixel_position / this.TILE_SIZE ) * this.TILE_SIZE;

	},


	/**
	 * Do stuff when there's a collision
	 */
	player_collision_callback: function( player, tile ) {

		// Game is over so no need to continue.
		if ( 'play' !== Game.game_state ) {

			return;

		}

		// If player hits head on ceiling then stop ascent.
		if ( player.body.blocked.up ) {

			player.body.jumpHeight = 9999999;
			player.body.velocity.y = 0;

		}

		if ( player.body.blocked.down ) {
			if ( Math.abs( Math.round( player.body.y ) - player.body.y ) < 0.1 ) {
				player.body.y = Math.round( player.body.y );
			}
		}

		if ( player.state === Game.Prefabs.Man.states.DIVE ) {
			player.state === Game.Prefabs.Man.states.FALL;
		}

		// Slide down walls.
		// Only triggered if the player is falling, and if their direction is downwards.
		if ( player.state === Game.Prefabs.Man.states.FALL && player.body.velocity.y > -2 ) {

			if ( player.body.blocked.left && player.controls.left ) {

				if ( Game.Utils.PlayerPhysics.can_wall_slide( player ) ) {
					player.state = Game.Prefabs.Man.states.WALL_SLIDE;
				}

			}

			if ( player.body.blocked.right && player.controls.right ) {

				if ( Game.Utils.PlayerPhysics.can_wall_slide( player ) ) {
					player.state = Game.Prefabs.Man.states.WALL_SLIDE;
				}

			}

		}

		// Dust cloud on big landing.
		if ( player.body.blocked.down ) {

			// Smaller jumps.
			// nothing.

			// Medium & large jumps.
			if ( player.deltaY > 1.4 ) {

				new Game.Prefabs.EffectDustJump( game, player.x, player.y );

			}

			if ( player.deltaY < -5 ) {

				player.state = Game.Prefabs.Man.states.CLIMB_PLATFORM;
				player.pause( 500 );

			}

		}



		// If player hits wall, and is moving upwards, and slightly across then stop ascent.
		// if ( player.body.velocity.y < 0 && Math.abs( player.deltaX ) > 0.5 ) {

		// 	// console.log( 'stop' );
		// 	player.body.jumpHeight = 9999999;
		// 	player.body.velocity.y = 0;

		// }

	},


	/**
	 * Pre collision checks to ensure the player is treated nicely.
	 *
	 * @param  {[type]} player [description]
	 * @param  {[type]} tile   [description]
	 * @return {[type]}        [description]
	 */
	player_collision_check: function( player, tile ) {

		// Default.
		return true;

	},


	/**
	 * Generate a cache slug for the current level.
	 *
	 * @param  {[type]} path [description]
	 * @return {[type]}      [description]
	 */
	map_slug: function( path ) {

		var slug = path;

		slug = slug.replace( /\//g, '-' );
		slug = slug.toLowerCase();
		slug = slug.replace( '.json', '' );

		return slug;

	},


	/**
	 * Draw a rectangle indicating the different zones available.
	 */
	debug_zones: function() {

		this.zones.forEach(
			function( zone ) {
				game.debug.rectangle( zone );
			}
		);

	},

};

/**
 * Create a smooth transition between two values.
 *
 * @param  {Number} current        Current value.
 * @param  {Number} target         Target value.
 * @param  {Number} [smoothing=10] Smoothing amount. A larger number = more iterations to complete the transition.
 * @return {Number}
 */
Math.smooth = function( current, target, smoothing ) {

	if ( ! smoothing ) {
		smoothing = 10;
	}

	var step = ( target - current ) / smoothing;

	// Step is small so let's finish the transition and reach the target.
	if ( Math.abs( step ) < 0.01 ) {
		return target;
	}

	return current + step;

};


Math.distance = function( x1, y1, x2, y2 ) {

	var a = x1 - x2;
	var b = y1 - y2;

	return Math.sqrt( ( a * a )  + ( b * b ) );

};
Game.Utils.Philosophy = {

	getRandom: function() {

		return Game.JSON.quotes[ Math.floor( Math.random() * this.count() ) ];

	},

	count: function() {

		return Game.JSON.quotes.length

	}

};
Game.Utils.PlayerAnimation = {

	run: function( man ) {

		if ( ! man.alive ) {
			return;
		}

		// Run an animation method based upon wether there is one available for the
		// current state or not.
		if ( 'function' === typeof this[ 'run_' + man.state ] ) {

			var old_animation = man.animation;

			this[ 'run_' + man.state ]( man );

			// Only play the animation if there's a method for the current
			// player state.
			//
			// If there's no method then it's likely there's another animation
			// playing. For example the man may have died.

			// If the animation changes then play the animation - else let it do it's own thing.
			if ( old_animation !== man.animation ) {
				man.animations.play( man.animation );
			}

		}

	},


	/**
	 * Do physics for idle.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_1: function( man ) {

		man.animation = 'idle';

		var man_speed = Math.abs( man.body.velocity.x );

		if ( man_speed > 5 ) {
			man.animation = 'walk';
		}

		if ( man_speed > 30 ) {
			man.animation = 'run';
		}

	},


	/**
	 * Flying animations.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_2: function( man ) {

		man.animation = 'fly';

	},


	/**
	 * Jump animation.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_3: function( man ) {

		man.animation = 'jump';

		if ( man.body.velocity.y > 2 ) {
			man.animation = 'fall';
		}

	},


	/**
	 * Crawl animation.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_4: function( man ) {

		man.animation = 'idle-crawl';

		if ( man.body.velocity.x > 2 || man.body.velocity.x < -2 ) {
			man.animation = 'crawl';
		}

	},

	/**
	 * Climb animation.
	 *
	 * @param  {[type]} man [description]
	 * @return {[type]}       [description]
	 */
	run_5: function( man ) {

		man.animation = 'idle-climb';

		if ( man.controls.down ) {
			man.animation = 'climb';
		}

		if ( man.controls.up ) {
			man.animation = 'climb';
		}

	},


	run_6: function( man ) {

		man.animation = 'climb-platform';

	},


	run_7: function( man ) {

		man.animation = 'superhero-landing';

	},


	run_8: function( man ) {

		man.animation = 'wall-slide';

	},

	run_9: function( man ) {

		man.animation = 'floor-slide';

	},

	run_10: function( man ) {

		man.animation = 'dive';

	},

};

Game.Utils.PlayerEffects = {

	/**
	 * Run the physics for the specified man.
	 *
	 * @param  {man} man The man to adjust.
	 * @return {null}
	 */
	run: function( man ) {

		if ( ! man.alive ) {
			return;
		}

		// Run a physics method based upon wether there is one available for the
		// current state or not.
		if ( 'function' === typeof this[ 'run_' + man.state ] ) {
			this[ 'run_' + man.state ]( man );
		}

		if ( this.canExplode( man ) ) {
			this.resetExplode( man );
		}

	},


	canExplode: function( man ) {

		if ( ! man.emit_effect ) {
			return true;
		}

		if ( man.emit_effect < game.time.time ) {
			return true;
		}

		return false;

	},


	resetExplode: function( man ) {

		var offset;

		switch( man.state ) {

			case Game.Prefabs.Man.states.FLY:

				offset = 200;
				break;

			case Game.Prefabs.Man.states.JUMP:

				offset = 150;
				break;

			default:

				offset = 250;

		}

		man.emit_effect = game.time.time + offset;

	},


	/**
	 * Do physics for walking.
	 *
	 * @param  {Object} man [description]
	 */
	run_1: function( man ) {

		if ( Math.abs( man.body.velocity.x ) > 30 && this.canExplode( man ) ) {

			new Game.Prefabs.EffectDust( game, man.x, man.y );

		}

		if ( man.controls.down && ! man.controls.up ) {

			// Traveling fast then let's slide instead!
			if ( Math.abs( man.body.velocity.x ) > 20 ) {

				new Game.Prefabs.EffectDustSlide( game, man.x, man.y );

			}

		}

		if ( man.controls.left && man.body.velocity.x > 0 ) {

			new Game.Prefabs.EffectDustSlide( game, man.x, man.y );

		}

		if ( man.controls.right && man.body.velocity.x < 0 ) {

			new Game.Prefabs.EffectDustSlide( game, man.x, man.y );

		}

	},


	/**
	 * Flying.
	 *
	 * @param {Object} man [description]
	 */
	run_2: function( man ) {

		if ( this.canExplode( man ) ) {

			new Game.Prefabs.EffectRocketBoots( game, man.x, man.y );

		}

	},


	/**
	 * Jumping/ Falling.
	 *
	 * @param {Object} man [description]
	 */
	run_3: function( man ) {

		if ( this.canExplode( man ) ) {

			new Game.Prefabs.EffectDust( game, man.x, man.y );

		}

	},


	/**
	 * Do physics for crawling.
	 *
	 * @param  {Object} man [description]
	 */
	run_4: function( man ) {


	},

	run_9: function( man ) {


	},


	run_5: function( man ) {


	},

	run_6: function( man ) {

	},

	run_7: function( man ) {

	},


	run_8: function( man ) {

	},

};

Game.Utils.PlayerPhysics = {

	// jumpMultiplier: 3.3,

	jumpMultiplier: 5.2,

	/**
	 * Run the physics for the specified man.
	 *
	 * @param  {man} man The man to adjust.
	 * @return {null}
	 */
	run: function( man ) {

		// If the man is attached to something then quit.
		//
		// The actual following is done in this.follow, and it should be called
		// in man.postUpdate to ensure things like physics and tweens are
		// completed.
		if ( man.follow ) {
			return;
		}

		if ( !man.alive ) {
			return;
		}

		this.update_direction( man );

		this.check_ladder( man );

		// Run a physics method based upon wether there is one available for the
		// current state or not.
		if ( 'function' === typeof this[ 'run_' + man.state ] ) {
			this[ 'run_' + man.state ]( man );
		}

	},


	/**
	 * Update the player collision size based upon their current state.
	 */
	update_collision: function( man ) {

		// Width must be no wider than 8 so that the player will fall through small holes.
		var width = 6;

		switch ( man.state ) {

			case Game.Prefabs.Man.states.FLOOR_SLIDE:
			case Game.Prefabs.Man.states.CRAWL:
			case Game.Prefabs.Man.states.DIVE:

				man.body.setSize( width, 8, 4, 7 );

				break;

			case Game.Prefabs.Man.states.CLIMB:

				man.body.setSize( width, 14, 4, 1 );

				break;

			default:

				man.body.setSize( width, 14, 4, 1 );

		}

	},

	can_wall_slide: function( man ) {

		// Offset by the width of a tile so we can be sure we are getting the tile next to the man.
		// Use the man scale to determine direction (since we flip the scale to mirror the animations).
		var x = man.x + ( Game.Utils.Map.TILE_SIZE * man.scale.x );
		// Push the y position towards the middle of the mans body so we can be sure he's near something he can hold on to.
		var y = man.y - 4;

		// Check if the tile the man is clinging on to is collidable.
		if ( Game.Utils.Map.TILE_COLLISION === Game.Utils.Map.get_tile( x, y, Game.Utils.Map.layer_collision ).index ) {

			// Check the man has not touched the floor.
			if ( !man.body.onFloor() ) {
				return true;
			}

		}

		return false;

	},

	head_collide: function( man ) {

		var x = man.x;
		var y = man.y - 15;

		if ( Game.Utils.Map.TILE_COLLISION === Game.Utils.Map.get_tile( x, y, Game.Utils.Map.layer_collision ).index ) {
			return true;
		}

		return false;

	},


	check_ladder: function( man ) {

		// If already climbing then quit.
		if ( Game.Prefabs.Man.states.CLIMB === man.state ) {
			return;
		}

		// If we are flying/ diving and moving fast then lets zoom past the ladder.
		if ( Game.Prefabs.Man.states.FLY || Game.Prefabs.Man.states.DIVE ) {
			if ( Math.abs( man.body.velocity.x ) > 40 ) {
				return;
			}
		}

		// Ladder.
		if ( man.controls.up ) {
			if ( Game.Utils.Map.point_overlap_ladder( man.x, man.y - Game.Utils.Map.TILE_HALF_SIZE ) ) {

				man.state = Game.Prefabs.Man.states.CLIMB;
				Game.Utils.ManagePlatforms.cancelLock( man );

			}
		}

		// If standing on top of a ladder then climb down it.
		if ( man.controls.down ) {
			if ( Game.Utils.Map.point_overlap_ladder( man.x, man.y + Game.Utils.Map.TILE_HALF_SIZE ) ) {

				man.state = Game.Prefabs.Man.states.CLIMB;
				Game.Utils.ManagePlatforms.cancelLock( man );

				man.y += Game.Utils.Map.TILE_SIZE;

			}
		}

	},


	/**
	 * Make the man follow any object that it has been attached to.
	 *
	 * @param  {man} man The man that should follow.
	 */
	follow: function( man ) {

		// Check to see if the man has been parented to anything.
		if ( man.follow ) {

			// Update the position.
			man.x = man.follow.x;
			man.y = man.follow.y;

		}

	},


	/**
	 * Flip the image so that it faces the correct direction.
	 *
	 * By default the images face right, so the default direction is 1. To flip
	 * the direction we set the x scale to -1.
	 */
	update_direction: function( man ) {

		var direction = null;

		// Moving left so flip.
		if ( man.body.velocity.x < -2 ) {

			direction = -1;

		}

		// Moving right so flip.
		if ( man.body.velocity.x > 2 ) {

			direction = 1;

		}

		// Only change the direction if there's enough change in speed.
		if ( direction ) {

			man.scale.x = direction;

		}

	},

	start_jump: function( man ) {

		man.jumpTimer = game.time.time + 300;

	},


	do_jump: function( man ) {

		// Trigger the jumping.
		man.body.jumpHeight = 1;
		man.state = Game.Prefabs.Man.states.JUMP;
		man.body.velocity.y = -20;

		// If on a moving platform then let's add the speed of the platform to the jump.
		if ( man.lockedTo && man.lockedTo.deltaY < 0 ) {
			man.body.velocity.y += man.lockedTo.deltaY * 40;
		}

		// Cancel attachment to platform.
		Game.Utils.ManagePlatforms.cancelLock( man );

		this.update_collision( man );

	},


	/**
	 * Do physics for walking.
	 *
	 * @param  {Object} man [description]
	 */
	run_1: function( man ) {

		Game.Utils.ManagePlatforms.checkLock( man );

		// Default properties.
		var x_speed = 3;

		man.body.velocity.y += 1;
		man.body.velocity.x *= 0.96;

		// Jump.
		// The jumpheight check prevents bouncing when you hold the jump button.
		if ( man.controls.up ) {

			if ( 0 === man.body.jumpHeight ) {

				this.do_jump( man );

			}

		} else {

			man.body.jumpHeight = 0;

		}

		if ( man.controls.down && !man.controls.up ) {

			man.state = Game.Prefabs.Man.states.CRAWL;

			// Traveling fast then let's slide instead!
			if ( Math.abs( man.body.velocity.x ) > 20 ) {

				man.state = Game.Prefabs.Man.states.FLOOR_SLIDE;

			}

			this.update_collision( man );

		}

		// If the character is falling then let's switch to jump mode.
		if ( man.body.velocity.y > 2 ) {

			man.state = Game.Prefabs.Man.states.JUMP;
			this.start_jump( man );
			this.update_collision( man );

		}

		// Walking.
		if ( man.controls.left ) {

			man.body.velocity.x -= x_speed;

		}

		if ( man.controls.right ) {

			man.body.velocity.x += x_speed;

		}

	},


	/**
	 * Flying.
	 *
	 * @param {Object} man [description]
	 */
	run_2: function( man ) {

		// reset velocity.
		var x_speed = 2;
		man.body.velocity.y -= 1;
		man.body.velocity.y *= 0.99;

		// Only apply horizontal friction if the controls are being used.
		// Otherwise friction in the air would look weird.
		if ( man.controls.left || man.controls.right ) {

			man.body.velocity.x *= 0.95;

		} else {

			man.body.velocity.x *= 0.99;

		}

		// Walk.
		if ( man.controls.left ) {

			man.body.velocity.x -= x_speed;

		} else if ( man.controls.right ) {

			man.body.velocity.x += x_speed;

		}

		if ( !man.controls.up ) {

			man.state = Game.Prefabs.Man.states.FALL;

		}

	},


	/**
	 * Jumping/ Falling.
	 *
	 * @param {Object} man [description]
	 */
	run_3: function( man ) {

		// Default properties.
		var x_speed = 2;

		man.body.velocity.y += 1.5;

		// Only apply horizontal friction if the controls are being used.
		// Otherwise friction in the air would look weird.
		if ( man.controls.left || man.controls.right ) {

			man.body.velocity.x *= 0.95;

		} else {

			man.body.velocity.x *= 0.99;

		}

		// Fly.
		// if ( man.controls.up && ! man.controls.prevUp && game.time.time > man.jumpTimer ) {

		// 	man.state = Game.Prefabs.Man.states.FLY;

		// 	// If the man is falling the slow the descent so that he doesn't
		// 	// use all the fuel not crashing.
		// 	if ( man.body.velocity.y > 0 ) {
		// 		man.body.velocity.y *= 0.25;
		// 	}

		// 	return;

		// }

		// Dive.
		if ( man.controls.down && !man.controls.prevDown ) {

			man.state = Game.Prefabs.Man.states.DIVE;
			man.body.velocity.x *= 5;
			this.update_collision( man );
			return;

		}

		// Jump.
		if ( man.controls.up ) {

			// If character has just started falling and they try to jump then
			// let them.
			if ( game.time.time < man.jumpTimer ) {

				this.do_jump( man );

			}

			/**
			 * Variable height jumping.
			 */
			var jumpLimit = 30;

			if ( man.body.jumpHeight > 0 && man.body.jumpHeight <= jumpLimit ) {

				var y_speed = -this.jumpMultiplier + ( man.body.jumpHeight / ( jumpLimit / this.jumpMultiplier ) );
				man.body.jumpHeight++;
				man.body.velocity.y += y_speed;

			}

			// If we have the rocket pack then allow more jumps.

		} else {

			// Reset jump height so that it no longer processes/
			man.body.jumpHeight = 0;

		}

		if ( man.body.onFloor() ) {

			man.state = Game.Prefabs.Man.states.WALK;

			this.update_collision( man );

			// console.log( man.deltaY );

			if ( man.deltaY > 1.8 ) {

				console.log( 'superhero!' );
				man.state = Game.Prefabs.Man.states.LANDING;
				game.camera.shake( 0.01, 250 );
				man.pause( 750 );
				return;

			}

		}

		// Walking.
		if ( man.controls.left ) {

			man.body.velocity.x -= x_speed;

		} else if ( man.controls.right ) {

			man.body.velocity.x += x_speed;

		}

	},


	/**
	 * Dive/ Diving.
	 */
	run_10: function( man ) {

		man.body.velocity.x *= 0.95;
		man.body.velocity.y += 1.5;

		if ( man.body.onFloor() || man.body.onWall() ) {
			man.state = Game.Prefabs.Man.states.FALL;
		}

	},


	/**
	 * Do physics for crawling.
	 *
	 * @param  {Object} man [description]
	 */
	run_4: function( man ) {

		// Default properties.
		var x_speed = 1;

		man.body.velocity.y += 0.6;
		man.body.velocity.x *= 0.95;

		if ( !man.controls.down && !this.head_collide( man ) ) {

			man.state = Game.Prefabs.Man.states.WALK;
			this.update_collision( man );

		}

		// If the character is falling then let's switch to jump mode.
		if ( man.body.velocity.y > 2 ) {

			man.state = Game.Prefabs.Man.states.JUMP;
			this.update_collision( man );

		}

		// Walking.
		if ( man.controls.left ) {

			man.body.velocity.x -= x_speed;

		}

		if ( man.controls.right ) {

			man.body.velocity.x += x_speed;

		}

	},

	run_9: function( man ) {

		// Default properties.
		man.body.velocity.y += 0.6;
		man.body.velocity.x *= 0.99;

		if ( !man.controls.down && !this.head_collide( man ) ) {

			man.state = Game.Prefabs.Man.states.WALK;
			this.update_collision( man );

		}

		// If the character is falling then let's switch to jump mode.
		if ( man.body.velocity.y > 2 ) {

			man.state = Game.Prefabs.Man.states.JUMP;
			this.update_collision( man );

		}

		// If we slow too much then switch to normal sliding.
		if ( Math.abs( man.body.velocity.x ) < 20 ) {
			man.state = Game.Prefabs.Man.states.CRAWL;
		}

	},


	run_5: function( man ) {

		// Stop all velocities on ladder.
		man.body.velocity.x = 0;
		man.body.velocity.y = 0;

		// Center on the ladder.
		if ( man.controls.up || man.controls.down ) {

			man.x = Game.Utils.Map.tile_coord( man.x ) + Game.Utils.Map.TILE_HALF_SIZE;

		}

		if ( man.controls.up ) {

			man.body.velocity.y = -20;

		}

		if ( man.controls.down ) {

			man.body.velocity.y = 30;

		}

		if ( !man.controls.up && !man.controls.down ) {

			if ( man.controls.left ) {

				man.state = Game.Prefabs.Man.states.JUMP;
				man.body.velocity.x = -20;
				man.body.velocity.y = -35;

			}

			if ( man.controls.right ) {

				man.state = Game.Prefabs.Man.states.JUMP;
				man.body.velocity.x = 20;
				man.body.velocity.y = -35;

			}

		}

		if ( !Game.Utils.Map.point_overlap_ladder( man.x, man.y - Game.Utils.Map.TILE_HALF_SIZE ) ) {

			man.state = Game.Prefabs.Man.states.FALL;
			man.jumpHeight = 9999;

			if ( man.controls.up ) {
				man.body.velocity.y = -20;
			}

		}

	},

	run_6: function( man ) {

		this.run_7( man );

	},

	run_7: function( man ) {

		if ( man.pauseTime < game.time.time ) {

			man.state = Game.Prefabs.Man.states.WALK;

		}

	},


	/**
	 * Wall slide.
	 */
	run_8: function( man ) {

		man.body.velocity.y += 1;
		man.body.velocity.y = man.body.velocity.y * 0.98;

		// Work out which way around the direction controls should be based upon
		// the wall the player is colliding with.
		var slide_control = man.controls.left;
		var jump_control = man.controls.right;

		if ( 1 === man.scale.x ) {
			slide_control = man.controls.right;
			jump_control = man.controls.left;
		}

		// Is the relevant grab direction being pressed (left/ right arrow).
		if ( slide_control ) {
			man.body.velocity.y = man.body.velocity.y * 0.8;
		}

		// Release slide if down key is pressed.
		if ( man.controls.down || man.controls.up ) {
			if ( !slide_control ) {
				man.state = Game.Prefabs.Man.states.FALL;
			}
		}

		// Jumping from a slide involves pressing the opposite direction to the hold.
		if ( jump_control ) {
			man.body.velocity.y = -50;
			man.body.velocity.x = -35 * man.scale.x;
			man.state = Game.Prefabs.Man.states.JUMP;
			this.start_jump( man );
			return;
		}

		// If we can no longer slide then let go and fall.
		if ( !this.can_wall_slide( man ) ) {
			man.state = Game.Prefabs.Man.states.FALL;
		}

	},

};

Game.Utils.Signposts = {

	/**
	 * Is the message signpost currently being read or not.
	 *
	 * @type {Boolean}
	 */
	active: false,

	/**
	 * The modal overlay background.
	 *
	 * @type {Object}
	 */
	overlay: null,

	/**
	 * The text object that sets the message string.
	 *
	 * @type {Object}
	 */
	overlay_text: null,

	/**
	 * The image that displays the overlay text.
	 *
	 * @type {Object}
	 */
	overlay_text_image: null,

	/**
	 * Info about the zone being used.
	 * @type {Object}
	 */
	zone: {},

	/**
	 * Time it takes to fade in the message and overlay.
	 * @type {Number}
	 */
	fade_duration: 120,

	/**
	 * Wait timer.
	 *
	 * @type {Number}
	 */
	wait_timer: 0,


	wait_timer_limit: 250,

	tween_text: null,

	tween_overlay: null,

	/**
	 * Initialize the signpost displays. Only needs to be called once.
	 *
	 * @param  {[type]} layers [description]
	 * @return {[type]}        [description]
	 */
	init: function( layers ) {

		this.overlay = new Phaser.Graphics( game );
		this.overlay.beginFill( Game.background_color, 0.8 );
		this.overlay.drawRect( 0, 0, game.width, game.height );
		this.overlay.endFill();

		layers.groupModal.add( this.overlay );

		this.overlay.alpha = 0;

		this.overlay_text = game.add.retroFont( 'font', 4, 6, Game.font_set, 8, 3, 1, 2, 1 );
		this.overlay_text.multiLine = true;
		this.overlay_text.autoUpperCase = false;

		this.overlay_text_image = game.add.image( game.width / 2, game.height / 2, this.overlay_text );
		this.overlay_text_image.anchor.setTo( 0.5, 0.5 );
		this.overlay_text_image.alpha = 0;

		layers.groupModal.add( this.overlay_text_image );

	},


	/**
	 * Display a signpost and it's message.
	 *
	 * @param  {[type]} message [description]
	 * @param  {[type]} zone    [description]
	 * @return {[type]}         [description]
	 */
	display: function( message, zone ) {

		// Already active so lets leave early.
		if ( this.active ) {
			return;
		}

		if ( undefined === message ) {
			return;
		}

		// Use a timer to reduce the liklihood of the player going through a
		// square and seeing the sign when they are not interested.
		this.wait_timer += game.time.elapsed;

		// Check the waited time against the limit. If it's greater then lets
		// see the signpost.
		if ( this.wait_timer > this.wait_timer_limit ) {
			this.show( message, zone );
		}

	},


	/**
	 * Show a sign.
	 *
	 * @param  {[type]} message [description]
	 * @param  {[type]} zone    [description]
	 */
	show: function( message, zone ) {

		// Save the current zone so that we can check when we leave it.
		this.zone = zone;

		message = this.process_message( message );

		// set overlay message
		this.overlay_text.text = Game.Utils.Text.wrap( message );

		this.stopTween();

		// add tweens
		this.tween_overlay = game.add.tween( this.overlay ).to( { alpha: 1 }, this.fade_duration ).start();
		this.tween_text = game.add.tween( this.overlay_text_image ).to( { alpha: 1 }, this.fade_duration ).start();

		// Set the signpost as active.
		this.active = true;

	},


	/**
	 * Hide a signpost and reset values so that it can be reused.
	 */
	hide: function() {

		this.active = false;
		this.zone = {};
		this.wait_timer = 0;

		var fade_duration = Math.ceil( this.fade_duration / 2 );

		this.stopTween();

		this.tween_overlay = game.add.tween( this.overlay ).to( { alpha: 0 }, fade_duration ).start();
		this.tween_text = game.add.tween( this.overlay_text_image ).to( { alpha: 0 }, fade_duration ).start();

	},


	stopTween: function() {

		if ( this.tween_overlay ) {
			this.tween_overlay.stop();
		}

		if ( this.tween_text ) {
			this.tween_text.stop();
		}

	},


	process_message: function( message ) {

		console.log( message );

		message = message.replace( '[PHILOSOPHY]', Game.Utils.Philosophy.getRandom() );
		message = message.replace( '[COINS-FOUND]', Game.Utils.Hud.coins.getValue() );
		message = message.replace( '[COINS-TOTAL]', Game.Utils.ManageCoins.getTotal() );

		return message;

	},


	/**
	 * Update the signposts.
	 *
	 * This turns off signpost display once you leave the signpost zone.
	 *
	 * @param  {[type]} player [description]
	 * @return {[type]}       [description]
	 */
	update: function( player ) {

		if ( this.active && this.zone && ! Game.Utils.MapZones.in_zone( player, this.zone ) ) {

			this.hide();

		}

	},

};

/**
 * Text utilities.
 *
 * Used to assist with displaying retrofont data.
 *
 * @type {Object}
 */
Game.Utils.Text = {

	/**
	 * Wrap retro font text to fit within a 64 pixel width.
	 *
	 * @param  {string} text The text to wordwrap.
	 * @return {string}      The wrapped text.
	 */
	wrap: function( text ) {

		var max_length = 60;
		var character_size = 4;
		var message = '';

		text = text.replace( /\|/g, "\n" );

		var sentences = text.split( "\n" );

		// Loop through sentences.
		for ( var i = 0; i < sentences.length; i++ ) {

			var words = sentences[ i ].split( ' ' );
			var line_length = 0;

			for ( var j = 0; j < words.length; j++ ) {

				var word = words[j].trim();

				if ( word.length < 1 ) {
					continue;
				}

				var word_length = ( word.length + 1 ) * character_size;

				line_length += word_length;

				if ( line_length > max_length ) {
					message += "\n";
					line_length = word_length;
				}

				message += word + ' ';

			}

			message += "\n";
			line_length = 0;

		}

		return message;

	},

};



/**
 * Sources
 *
 * https://www.philosophybasics.com/general_quotes.html
 * http://www.quotegarden.com/philosophical.html
 */
Game.JSON.quotes = [
	'Whereof one cannot speak, thereof one must be silent',
	'I think therefore I am',
	'One cannot step twice in the same river',
	'To be is to be perceived',
	'Liberty consists in doing what one desires',
	'Even while they teach, one learns',
	'Leisure is the mother of philosophy',
	'Happiness is the highest good',
	'The only thing I know is that I know nothing',
	'In everything, there is a share of everything',
	'We are too weak to discover the truth by reason alone',
	'Believe those who are seeking the truth; doubt those who find it',
	'Losing an illusion makes you wiser than finding a truth',
	'When the student is ready, the master appears',
	'If you think you are free, there is no escape possible',
	'Do not miss the donut by looking through the hole',
	'You can not wake a person who is pretending to be asleep',
	'To learn something new, take the path that you took yesterday',
	'The obstacle is the path',
	'It is easy to stand a pain, but difficult to stand an itch',
	'You exist in time, but you belong to eternity',
	'Tomorrow always comes, and today is never yesterday',
	'The tighter you squeeze, the less you have',
	'It is always Now',
	'There are more lines formed than things worth waiting for',
	'To believe with certainty we must begin with doubting',
];

Game.JSON.signposts = {
	'intro': 'Find the Keys and Coins to Escape.',
	'orange-door': 'The Orange key opens the Orange door. Check up top!',
	'philosophy': '[PHILOSOPHY]',
	'fizz-buzz': '1. 2. Fizz. 4. Buzz. Fizz. 7. 8. Fizz. Buzz.',
	'exit': 'Find 200 coins to Exit!',
	'congratulations': 'You did it! You are free!',
	'coin-challenge': 'You found [COINS-FOUND] of [COINS-TOTAL] coins!',
	'secrets': 'Look out for the many secrets.',
};


Game.Prefabs.Effect = function( game, x, y, type, group ) {

	// Setup Effect.
	Phaser.Sprite.call( this, game, x, y, type );

	// Add to the display group.
	group.add( this );

	this.bringToTop();

};


Game.Prefabs.Effect.prototype = Object.create( Phaser.Sprite.prototype );

Game.Prefabs.Effect.constructor = Game.Prefabs.Effect;


Game.Prefabs.Effect.prototype.explode = function() {

	var animation = this.animations.play( 'explode' );

	animation.onComplete.add(
		this.kill,
		this
	);

};
/**
 * Coin object
 */
Game.Prefabs.Coin = function( game, x, y, group ) {

	// Setup Coin.
	Phaser.Sprite.call( this, game, x + Game.Utils.Map.TILE_HALF_SIZE, y + Game.Utils.Map.TILE_HALF_SIZE, 'coin' );

	// Add coin animations.
	this.animations.add( 'spin', [ 0, 1, 2, 3 ], 6, true );
	this.animations.add( 'explode',
		[
			0, 1, 2, 3,
			0, 1, 2, 3,
			4, 5, 6, 7, 8
		],
		30, false );

	// Set the anchor to the middle to center the coin on the tile.
	this.anchor.setTo( 0.5, 0.5 );

	// Play the spin animation by default.
	this.animations.play( 'spin' );

	// Add to the display group.
	group.add( this );

};


Game.Prefabs.Coin.prototype = Object.create( Phaser.Sprite.prototype );


Game.Prefabs.Coin.constructor = Game.Prefabs.Coin;


/**
 * Collect the coin
 *
 * Play collection anuimation and then remove the coin from the game.
 *
 * @param  {[type]} skier [description]
 * @return {[type]}       [description]
 */
Game.Prefabs.Coin.prototype.collect = function() {

	var animation = this.animations.play( 'explode' );
	this.bringToTop();
	this.alive = false;

	var tween = game.add.tween( this );
	tween.to( { y: this.y - 8 }, 200 );
	tween.start();

	// When the animation completes, kill the coin.
	animation.onComplete.add(
		this.kill,
		this
	);

};


/**
 * Computer object
 */
Game.Prefabs.Computer = function( game, x, y, group, properties ) {

	// Setup computer.
	Phaser.Sprite.call( this, game, x + Game.Utils.Map.TILE_HALF_SIZE, y, 'terminal' );

	// Add computer animations.
	this.animations.add( 'blink', [ 0, 1 ], 2, true );

	console.log( 'new computer' );

	// Set the anchor to the middle to center the computer on the tile.
	this.anchor.setTo( 0.5, 0 );

	// Play the spin animation by default.
	this.animations.play( 'blink' );

	this.computerProperties = properties;


	Game.Utils.Map.add_zone(
		{
			type: 'computer',
			x: x - Game.Utils.Map.TILE_HALF_SIZE,
			y: y,
			width: Game.Utils.Map.TILE_SIZE * 2,
			height: Game.Utils.Map.TILE_SIZE * 2,
			name: properties.name,
		}
	);


	// Add to the display group.
	group.add( this );

};


Game.Prefabs.Computer.prototype = Object.create( Phaser.Sprite.prototype );


Game.Prefabs.Computer.constructor = Game.Prefabs.Computer;

/**
 * Key object
 */
Game.Prefabs.Door = function( game, x, y, type, group, properties ) {

	console.log( 'type of door =', type );

	if ( ! type || type === 'door' ) {
		type = 'door-vertical';
	}

	if ( ! properties.properties ) {
		properties.properties = {};
	}

	if ( ! properties.properties.color ) {
		properties.properties.color = 'blue';
	}

	if ( ! properties.properties.callback ) {
		properties.properties.callback = '';
	}


	var slug = type + '-' + properties.properties.color;

	// Setup Key.
	Phaser.Sprite.call( this, game, x + Game.Utils.Map.TILE_HALF_SIZE, y + Game.Utils.Map.TILE_HALF_SIZE, slug );

	// Add key animations.
	this.animations.add( 'shut', [ 0 ], 5, false );
	this.animations.add( 'open', [ 0, 1, 2, 3, 4 ], 24, false );
	this.animations.add( 'close', [ 4, 3, 2, 1, 0 ], 24, false );

	console.log( 'new door', slug );

	// Set the anchor to the middle to center the key on the tile.
	this.anchor.setTo( 0.5, 0.5 );

	// Play the spin animation by default.
	this.animations.play( 'shut' );

	var tileX = x / Game.Utils.Map.TILE_SIZE;
	var tileY = y / Game.Utils.Map.TILE_SIZE;

	this.name = properties.name;

	this.doorTiles = [];
	this.doorTiles.push( [ tileX, tileY - 1 ] );
	this.doorTiles.push( [ tileX, tileY ] );
	this.doorTiles.push( [ tileX, tileY + 1 ] );

	Game.Utils.Map.add_tile_collision( this.doorTiles, Game.Utils.Map.TILE_COLLISION, [ 1, 1, 1, 1 ] );

	Game.Utils.Map.add_zone(
		{
			door: this,
			type: 'door',
			x: x - ( Game.Utils.Map.TILE_SIZE * 2 ),
			y: y - ( Game.Utils.Map.TILE_SIZE * 2 ),
			width: Game.Utils.Map.TILE_SIZE * 5,
			height: Game.Utils.Map.TILE_SIZE * 5,
			name: properties.name,
			callback: properties.properties.callback,
		}
	);

	// Add to the display group.
	group.add( this );

};


Game.Prefabs.Door.prototype = Object.create( Phaser.Sprite.prototype );


Game.Prefabs.Door.constructor = Game.Prefabs.Door;


Game.Prefabs.Door.prototype.open = function() {

	if ( 'open' === this.state ) {
		return;
	}

	this.animations.play( 'open', false );

	this.state = 'open';

};



/**
 * Setup a player object.
 *
 * This is generally a user controlled Skier.
 * A player extends the Skiers properties and methods.
 *
 * @param  {Object} game  The Phaser Game object.
 * @param  {Number} x     The player x position.
 * @param  {Number} y     The player y position.
 * @param  {Object} group The player display group.
 */
Game.Prefabs.EffectDustJump = function( game, x, y ) {

	// Call parent class.
	Game.Prefabs.Effect.call( this, game, x, y, 'effect-dust-jump', Game.Utils.Layers.layers.groupElements );

	this.animations.add(
		'explode',
		[ 0, 1, 2, 3, 4, 5, 6, 7 ],
		20,	// 24
		false
	);

	this.anchor.setTo( 0.5, 1 );

	this.explode();

};


Game.Prefabs.EffectDustJump.prototype = Object.create( Game.Prefabs.Effect.prototype );


Game.Prefabs.EffectDustJump.constructor = Game.Prefabs.EffectDustJump;


/**
 * Setup a player object.
 *
 * This is generally a user controlled Skier.
 * A player extends the Skiers properties and methods.
 *
 * @param  {Object} game  The Phaser Game object.
 * @param  {Number} x     The player x position.
 * @param  {Number} y     The player y position.
 * @param  {Object} group The player display group.
 */
Game.Prefabs.EffectDustSlide = function( game, x, y ) {

	// Call parent class.
	Game.Prefabs.Effect.call( this, game, x, y, 'effect-dust-jump', Game.Utils.Layers.layers.groupElements );

	this.animations.add(
		'explode',
		[ 8, 9, 10, 11, 12, 13, 14, 15, 16, 17 ],
		18,
		false
	);

	this.anchor.setTo( 0.5, 1 );

	this.explode();

};


Game.Prefabs.EffectDustSlide.prototype = Object.create( Game.Prefabs.Effect.prototype );


Game.Prefabs.EffectDustSlide.constructor = Game.Prefabs.EffectDustSlide;


/**
 * Setup a player object.
 *
 * This is generally a user controlled Skier.
 * A player extends the Skiers properties and methods.
 *
 * @param  {Object} game  The Phaser Game object.
 * @param  {Number} x     The player x position.
 * @param  {Number} y     The player y position.
 * @param  {Object} group The player display group.
 */
Game.Prefabs.EffectDust = function( game, x, y ) {

	// Call parent class.
	Game.Prefabs.Effect.call( this, game, x + game.rnd.between( -1, 1 ), y + game.rnd.between( -1, 1 ), 'effect-dust-jump', Game.Utils.Layers.layers.groupElements );

	this.animations.add(
		'explode',
		[ 22, 23, 24, 25 ],
		8,
		false
	);

	this.anchor.setTo( 0.5, 1.5 );

	this.explode();

	this.sendToBack();

};


Game.Prefabs.EffectDust.prototype = Object.create( Game.Prefabs.Effect.prototype );


Game.Prefabs.EffectDust.constructor = Game.Prefabs.EffectDust;


/**
 * Setup a player object.
 *
 * This is generally a user controlled Skier.
 * A player extends the Skiers properties and methods.
 *
 * @param  {Object} game  The Phaser Game object.
 * @param  {Number} x     The player x position.
 * @param  {Number} y     The player y position.
 * @param  {Object} group The player display group.
 */
Game.Prefabs.EffectRocketBoots = function( game, x, y ) {

	// Call parent class.
	Game.Prefabs.Effect.call( this, game, x, y, 'effect-dust-jump', Game.Utils.Layers.layers.groupElements );

	this.animations.add(
		'explode',
		[ 18, 19, 20, 21 ],
		6,
		false
	);

	this.anchor.setTo( 0.5, -0.4 );

	this.explode();

};


Game.Prefabs.EffectRocketBoots.prototype = Object.create( Game.Prefabs.Effect.prototype );


Game.Prefabs.EffectRocketBoots.constructor = Game.Prefabs.EffectRocketBoots;


/**
 * Create a HUD Counter object.
 *
 * A HUD Counter object displays game properties such as time remaining, coins
 * collected etc.
 *
 * @param  {object} game  [description]
 * @param  {int} 	x     [description]
 * @param  {int} 	y     [description]
 * @param  {object} group [description]
 * @return {object}
 */
Game.Prefabs.HudCounter = function( game, group ) {

	Phaser.Sprite.call( this, game, 0, 0, 'hud' );

	this.counter = game.add.retroFont( 'font', 4, 6, Game.font_set, 8, 3, 1, 2, 1 );

	this.counter_image = game.add.image( 0, 0, this.counter );

	this.updatePosition();

	group.add( this );
	group.add( this.counter_image );

};

Game.Prefabs.HudCounter.prototype = Object.create( Phaser.Sprite.prototype );

Game.Prefabs.HudCounter.prototype.constructor = Game.Prefabs.HudCounter;


/**
 * Constant that lists frame ids for the different counter designs.
 *
 * @type {Object}
 */
Game.Prefabs.HudCounter.COUNTER_TYPE = {
	'default': 0,
	'distance': 1,
	'coin': 2,
	'time': 3,
};


/**
 * Update the text value of the counter text.
 *
 * @param  {string} value The new value to display in the counter widget.
 */
Game.Prefabs.HudCounter.prototype.setText = function( value ) {

	this.counter.text = value.toString();
	this.updatePosition();

};


/**
 * Get the current hud counters text value.
 *
 * @return {string}
 */
Game.Prefabs.HudCounter.prototype.getText = function() {

	return this.counter.text;

};


/**
 * Get the numerical value of the current hud counter.
 *
 * @return {float} [description]
 */
Game.Prefabs.HudCounter.prototype.getValue = function() {

	return parseFloat( this.counter.text );

};


/**
 * Update the position of the hud counter, and its text object.
 */
Game.Prefabs.HudCounter.prototype.updatePosition = function() {

	this.counter_image.x = this.x + 8;
	this.counter_image.y = this.y + 1;

};

/**
 * Key object
 */
Game.Prefabs.Key = function( game, x, y, group, properties ) {

	if ( ! properties.properties ) {
		properties.properties = {};
	}

	if ( ! properties.properties.color ) {
		properties.properties.color = 'blue';
	}

	// Setup Key.
	Phaser.Sprite.call( this, game, x + Game.Utils.Map.TILE_HALF_SIZE, y + Game.Utils.Map.TILE_HALF_SIZE, 'key-' + properties.properties.color );

	// Add key animations.
	this.animations.add(
		'spin',
		[ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11 ],
		5,
		true
	);

	this.animations.add(
		'explode',
		[
			4, 5, 6, 7, 8, 9, 10, 11,
			0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11,
			12, 13, 14, 15, 16, 17, 18
		],
		48,
		false
	);

	console.log( 'new key', properties.properties.color );

	// Set the anchor to the middle to center the key on the tile.
	this.anchor.setTo( 0.5, 0.5 );

	// Play the spin animation by default.
	this.animations.play( 'spin' );

	this.keyProperties = properties;

	// Add to the display group.
	group.add( this );

};


Game.Prefabs.Key.prototype = Object.create( Phaser.Sprite.prototype );


Game.Prefabs.Key.constructor = Game.Prefabs.Key;


/**
 * Collect the key
 *
 * Play collection anuimation and then remove the key from the game.
 *
 * @param  {[type]} skier [description]
 * @return {[type]}       [description]
 */
Game.Prefabs.Key.prototype.collect = function() {

	this.bringToTop();
	this.alive = false;

	var tween = game.add.tween( this );
	tween.to( { y: this.y - 8 }, 300 );
	tween.start();

	var animation = this.animations.play( 'explode' );

	Game.Utils.ManageDoors.unlockDoor( this.keyProperties.name );

	// When the animation completes, kill the key.
	animation.onComplete.add(
		this.kill,
		this
	);

};


/**
 * Skier object
 * Controls all skiers, their physics, and their properties.
 */
Game.Prefabs.Man = function( game, x, y, group ) {

	// Setup Skier.
	//
	// This uses a null display object. This allows me to apply physics to
	// the skier independently of the character display image. I can then
	// snap the character display image to whole pixels - which keeps
	// things looking nice and crisp whilst having accurate physics.
	Phaser.Sprite.call( this, game, x, y, 'player' );

	// Setup Skier Physics.
	game.physics.enable( this, Phaser.Physics.ARCADE );

	// Skier display image.
	this.anchor.setTo( 0.5, 0.5 );

	// Properties.
	this.state = '';
	this.state_old = '';
	this.state_updated = false;
	this.pname = 'skier';

	this.locked = false;
	this.lockedTo = null;

	// Physics Settings.

	// No gravity - it's a top down game and the game physics take care of downward motion.
	this.gravity = 0;

	// Increase tile padding to ensure the character does not pass through tiles by mistake.
	this.body.tilePadding.set( 16, 16 );

	// Not allowed to travel outside world bounds.
	this.body.collideWorldBounds = true;

	this.body.jumpHeight = 0;

	// Skier animations.
	this.animations.add( 'idle', [ 0, 1 ], 2, true );
	this.animations.add( 'walk', [ 2, 3, 4, 5 ], 4, true );
	this.animations.add( 'run', [ 26, 27, 28, 29 ], 6, true );
	this.animations.add( 'jump', [ 6 ], 1, false );
	this.animations.add( 'fall', [ 7 ], 1, false );
	this.animations.add( 'dive', [ 30 ], 1, false );
	this.animations.add( 'idle-crawl', [ 9 ], 1, false );
	this.animations.add( 'crawl', [ 8, 9, 10, 11 ], 5, true );
	this.animations.add( 'wall-slide', [ 12 ], 1, false );
	this.animations.add( 'fly', [ 13, 14 ], 6, true );
	this.animations.add( 'floor-slide', [ 15 ], 1, false );
	this.animations.add( 'idle-climb', [ 16 ], 1, false );
	this.animations.add( 'climb', [ 16, 17 ], 6, true );
	this.animations.add( 'slide-down', [ 18 ], 1, false );
	this.animations.add( 'superhero-landing', [ 19, 20, 21 ], 15, false );
	this.animations.add( 'climb-platform', [ 22, 23, 24, 25 ], 10, false );


	// Add elements to display groups.
	// The order is important. Ensures what needs to be seen, is seen.

	// Add Man.
	group.add( this );

	// Default Height settings.
	this.tile_height = 0;
	this.tile_old_height = 0;

	// Currently playing animation.
	this.animation = '';

	// Initialize the controls.
	this.controls = [];

	// Make sure the player is enabled.
	this.enable();
	this.reset();

};


Game.Prefabs.Man.prototype = Object.create( Phaser.Sprite.prototype );

Game.Prefabs.Man.constructor = Game.Prefabs.Man;


/**
 * Skier movenent state constants.
 *
 * @type {Object}
 */
Game.Prefabs.Man.states = {
	WALK: 1,
	FLY: 2,
	JUMP: 3,
	FALL: 3,
	CRAWL: 4,
	CLIMB: 5,
	CLIMB_PLATFORM: 6,
	LANDING: 7,
	WALL_SLIDE: 8,
	FLOOR_SLIDE: 9,
	DIVE: 10,
};


/**
 * Player movement stub. Is used in skier-player
 */
Game.Prefabs.Man.prototype.controller = function() { };


/**
 * Player physics stub. Is used in skier-player
 */
Game.Prefabs.Man.prototype.physics = function() {


};


/**
 * Update Skier Positions.
 */
Game.Prefabs.Man.prototype.update = function() {

	// Update movement and physics.
	this.controller();
	this.physics();

	// Check map zones.
	// This decides if the skier should be skiing or walking etc.
	Game.Utils.MapZones.check( this );

	if ( this.alive ) {

		Game.Utils.MapEnvironment.run( this );

	}

	// Player special effects.
	Game.Utils.PlayerEffects.run( this );
	// Run physics.
	Game.Utils.PlayerPhysics.run( this );
	// Run animations.
	Game.Utils.PlayerAnimation.run( this );

	// Update default Phaser sprite stuff.
	Phaser.Sprite.prototype.update.call( this );

	this.check_state();

};


/**
 * Update Skier Positions.
 */
Game.Prefabs.Man.prototype.postUpdate = function() {

	Phaser.Sprite.prototype.postUpdate.call( this );

	Game.Utils.PlayerPhysics.follow( this );

};


/**
 * Check the skier state and update state properties accordingly.
 */
Game.Prefabs.Man.prototype.check_state = function() {

	this.state_updated = false;

	if ( this.state !== this.state_old ) {

		this.state_updated = true;

	}

	this.state_old = this.state;

};


/**
 * Disable a skier so it can no longer ski.
 *
 * Also physics don't affect it.
 */
Game.Prefabs.Man.prototype.disable = function() {

	this.alive = false;
	this.body.enable = false;

};


/**
 * Re-enable a skier so it once again skis the slopes.
 */
Game.Prefabs.Man.prototype.enable = function() {

	this.alive = true;
	this.body.enable = true;

};


Game.Prefabs.Man.prototype.pause = function( delay ) {

	this.body.velocity.x = 0;
	this.body.velocity.y = 0;

	this.pauseTime = game.time.time + delay;

};


/**
 * Reset MAn properties.
 *
 * Resets things like velocity and skiing state.
 */
Game.Prefabs.Man.prototype.reset = function() {

	this.state = Game.Prefabs.Man.states.WALK;

	this.pauseTime = 0;

	// Reset speeds.
	this.body.velocity.x = 0;
	this.body.velocity.y = 0;

	// Reset the bounding box.
	Game.Utils.PlayerPhysics.update_collision( this );

}


/**
 * Make a skier stick to another object.
 *
 * The skier will attach itself to the specified objects location.
 *
 * @param  {Object} parent The object to stick to. Set this to null to
 * break the connection.
 */
Game.Prefabs.Man.prototype.attachTo = function( parent ) {

	if ( !parent ) {
		parent = null;
	}

	this.follow = parent;

};


Game.Prefabs.Platform = function ( game, properties, group ) {

	if ( 'undefined' === typeof group ) {
		group = game.world;
	}

	if ( ! properties.key ) {
		properties.key = 'platform';
	}

	this.path = properties.polyline;

	Phaser.Sprite.call( this, game, properties.x + this.path[0][0], properties.y + this.path[0][1], 'empty' );

	this.image = game.add.sprite( this.x, this.y, properties.key );

	this.width = this.image.width;
	this.height = this.image.height;

	// Set platform physics.
	game.physics.arcade.enable( this );

	this.body.customSeparateX = true;
	this.body.customSeparateY = true;
	this.body.allowGravity = false;
	this.body.immovable = true;

	// Only top collision.
	this.body.checkCollision.down = false;
	this.body.checkCollision.left = false;
	this.body.checkCollision.right = false;

	this.addMotionPath();

	console.log( 'new platform', properties );

	group.add( this );
	group.add( this.image );

	this.image.anchor.setTo( 0.5, 0 );
	this.anchor.setTo( 0.5, 0 );

};

Game.Prefabs.Platform.prototype = Object.create( Phaser.Sprite.prototype );

Game.Prefabs.Platform.prototype.constructor = Game.Prefabs.Platform;


Game.Prefabs.Platform.prototype.preRender = function( man ) {

	// if ( man.lockedTo === this ) {
	// 	this.image.x = man.x;
	// } else {
	// }

	this.image.x = Math.round( this.x );
	this.image.y = Math.floor( this.y );

};


Game.Prefabs.Platform.prototype.addMotionPath = function() {

	this.tweenX = this.game.add.tween( this.body );
	this.tweenY = this.game.add.tween( this.body );

	var totalDistance = this.calculateDistance();
	var duration = ( totalDistance / 16 ) * 1000;

	var segmentDuration = 0;
	var segmentDistance = 0;

	// Calculate path distance.
	console.log( 'path distance', totalDistance, duration );

	this.delay();

	// Add motion path.
	// Start from 1 so that we skip the initial position.
	for ( var i = 1; i < this.path.length; i++ ) {

		segmentDistance = Math.distance( this.path[i-1][0], this.path[i-1][1], this.path[i][0], this.path[i][1] );
		segmentDuration = Math.round( ( segmentDistance / totalDistance ) * duration );

		this.tweenX.to( { x: this.x + this.path[i][0] }, segmentDuration );
		this.tweenY.to( { y: this.y + this.path[i][1] }, segmentDuration );

	}

	this.delay();

	// Loop backwards so we can get the yoyo effect.
	for ( var i = this.path.length - 2; i >= 0; i-- ) {

		segmentDistance = Math.distance( this.path[i+1][0], this.path[i+1][1], this.path[i][0], this.path[i][1] );
		segmentDuration = Math.round( ( segmentDistance / totalDistance ) * duration );

		this.tweenX.to( { x: this.x + this.path[i][0] }, segmentDuration );
		this.tweenY.to( { y: this.y + this.path[i][1] }, segmentDuration );

	}

	// Aaaaand, repeat.
	this.tweenX.repeatAll( -1 );
	this.tweenY.repeatAll( -1 );

	this.start();

};

Game.Prefabs.Platform.prototype.delay = function() {

	this.tweenX.to( { x: '+0' }, 1500 );
	this.tweenY.to( { y: '+0' }, 1500 );

};

Game.Prefabs.Platform.prototype.calculateDistance = function() {

	var totalDistance = 0;

	for ( var i = 0; i < this.path.length - 1; i++ ) {

		totalDistance += Math.distance( this.path[i][0], this.path[i][1], this.path[i+1][0], this.path[i+1][1] );

	}

	return totalDistance;

};

Game.Prefabs.Platform.prototype.start = function () {

	this.tweenX.start();
	this.tweenY.start();

};

Game.Prefabs.Platform.prototype.stop = function () {

	this.tweenX.stop();
	this.tweenY.stop();

};

/**
 * Setup a player object.
 *
 * This is generally a user controlled Skier.
 * A player extends the Skiers properties and methods.
 *
 * @param  {Object} game  The Phaser Game object.
 * @param  {Number} x     The player x position.
 * @param  {Number} y     The player y position.
 * @param  {Object} group The player display group.
 */
Game.Prefabs.Player = function( game, x, y, group ) {

	// Call parent class.
	Game.Prefabs.Man.call( this, game, x, y, group );

	this.pname = 'player';

};


Game.Prefabs.Player.prototype = Object.create( Game.Prefabs.Man.prototype );


Game.Prefabs.Player.constructor = Game.Prefabs.Player;


/**
 * Move player.
 *
 * This method uses the player controls, and overrides the skier method which
 * will (eventually) do something similar in a multiplayer situation.
 */
Game.Prefabs.Player.prototype.controller = function() {

	// Store the previous controls.
	this.controls.prevUp = this.controls.up;
	this.controls.prevDown = this.controls.down;
	this.controls.prevLeft = this.controls.left;
	this.controls.prevRight = this.controls.right;
	this.controls.prevAction = this.controls.action;

	// Controls.
	this.controls.up = Game.Utils.Controls.cursor.up.isDown;
	this.controls.down = Game.Utils.Controls.cursor.down.isDown;
	this.controls.left = Game.Utils.Controls.cursor.left.isDown;
	this.controls.right = Game.Utils.Controls.cursor.right.isDown;
	this.controls.action = Game.Utils.Controls.action.isDown;

};


/**
 * Run arcade physics on the player.
 */
Game.Prefabs.Player.prototype.physics = function() {

	if ( this.follow || !this.alive ) {
		return;
	}

	// console.log( Game.Utils.Map.layer_collision );

	// game.physics.arcade.collide( this, Game.Utils.Map.layer_collision );

	// World collision
	game.physics.arcade.collide( this, Game.Utils.Map.layer_collision, Game.Utils.Map.player_collision_callback );

	// Platform collision
	game.physics.arcade.collide( this, Game.Utils.ManagePlatforms.platforms, Game.Utils.ManagePlatforms.collision_callback );

	// Stop crazy floating point maths where the number never actually zeroes because of friction.
	if ( Math.abs( this.body.velocity.x ) < 0.01 ) {
		this.body.velocity.x = 0;
	}

	// switch( this.state ) {

	// 	// If walking.
	// 	case Game.Prefabs.Man.states.WALK:

	// 		game.physics.arcade.collide( this, Game.Utils.Map.layer_collision );

	// 		break;

	// 	// Everything else.
	// 	// Skiing, jumping, etc.
	// 	default:

	// 		game.physics.arcade.collide( this, Game.Utils.Map.layer_collision, Game.Utils.Map.player_collision_callback, Game.Utils.Map.player_collision_check, this );

	// 		break;

	// }

};


/* global game, Phaser, social */

Game.States.Boot = function( game ) {

}

Game.States.Boot.prototype = {

	preload: function() {

		game.load.image( 'progressBar', '/assets/games/star-raid/images/loading.png' );

		// Align game to the center of the available space.
		game.scale.pageAlignHorizontally = true;
		game.scale.pageAlignVertically = true;

		// Make game stretch to fill screen fully
		game.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;

		// Make game nice and crisp (as crispy as can be).
		game.renderer.renderSession.roundPixels = true;
		Phaser.Canvas.setImageRenderingCrisp( game.canvas, true );
		game.stage.smoothed = false;
		game.antialias = false;

		// update game scale.
		game.scale.refresh();

		// Set a background color.
		game.stage.backgroundColor = Game.background_color;

		// Setup arcade physics.
		game.physics.startSystem( Phaser.Physics.ARCADE );
		game.physics.arcade.TILE_BIAS = 8;

		Game.Utils.Camera.init();

		game.camera.roundPx = true;

		if ( Game.desiredFps ) {
			game.time.desiredFps = Game.desiredFps;
		}

	},

	create: function() {

		// switch to the loading state
		game.state.start( 'load' );

		// game.renderer.renderSession.roundPixels = true; // Round pixels for the renderer
		// Phaser.Canvas.setImageRenderingCrisp( game.canvas ); // Set image rendering to be crisp (no antialiasing)
		// Phaser.Stage.scaleMode = Phaser.StageScaleMode.SHOW_ALL; // Ensure the scale mode shows all content

	}

};

/* global game, CocoonJS */

Game.States.LoadWorld = {

	params: null,

	init: function( params ) {

		this.params = [];

		if ( params ) {
			this.params = params;
			this.params.slug = Game.Utils.Map.map_slug( this.params.path );

			console.log( this.params );
		}

	},

	preload: function() {

		// Add a progress bar
		var progressBar = game.add.sprite( game.world.centerX, game.world.centerY, 'progressBar' );
		progressBar.anchor.setTo( 0.5, 0.5 );
		game.load.setPreloadSprite( progressBar );

		this.load.path = '/assets/games/star-raid/';

		// Check if the file has already been loaded so we don't load it again.
		if ( !game.cache.checkTilemapKey( this.params.slug ) ) {

			var path = 'levels/' + this.params.path + '.json';

			game.load.tilemap( this.params.slug, path, null, Phaser.Tilemap.TILED_JSON );

			console.log( 'load map:', this.params.slug, path );

		}

	},

	create: function() {

		game.state.start( 'world', true, false, this.params );

	},

};

/* global game, CocoonJS */

Game.States.Load = {

	init: function() {

		this.input.maxPointers = 1;

		this.scale.pageAlignHorizontally = true;

	},

	preload: function() {

		// Add a progress bar
		var progressBar = game.add.sprite( game.world.centerX, game.world.centerY, 'progressBar' );
		progressBar.anchor.setTo( 0.5, 0.5 );
		game.load.setPreloadSprite( progressBar );

		this.load.path = '/assets/games/star-raid/';


		// Images

		game.load.image( 'world', 'images/world.png' );
		game.load.image( 'collision', 'images/collision.png' );
		game.load.image( 'intro', 'images/splash-screen.png' );
		game.load.image( 'font', 'images/font.png' );
		game.load.image( 'empty', 'images/null.png' );


		// Sprites

		game.load.spritesheet( 'confetti', 'images/confetti.png', 2, 2 );
		game.load.spritesheet( 'door-vertical-blue', 'images/door-vertical-blue.png', 8, 24 );
		game.load.spritesheet( 'door-vertical-green', 'images/door-vertical-green.png', 8, 24 );
		game.load.spritesheet( 'door-vertical-orange', 'images/door-vertical-orange.png', 8, 24 );
		game.load.spritesheet( 'door-vertical-red', 'images/door-vertical-red.png', 8, 24 );
		game.load.spritesheet( 'player', 'images/main-character.png', 14, 30 );
		game.load.spritesheet( 'hud', 'images/hud.png', game.width, 8 );
		game.load.spritesheet( 'coin', 'images/coins.png', 12, 12 );
		game.load.spritesheet( 'effect-dust-jump', 'images/effect-dust-jump.png', 18, 7 );
		game.load.spritesheet( 'key-blue', 'images/key-blue.png', 10, 10 );
		game.load.spritesheet( 'key-orange', 'images/key-orange.png', 10, 10 );
		game.load.spritesheet( 'key-red', 'images/key-red.png', 10, 10 );
		game.load.spritesheet( 'key-green', 'images/key-green.png', 10, 10 );
		game.load.spritesheet( 'terminal', 'images/terminal.png', 12, 16 );
		game.load.spritesheet( 'platform', 'images/platform.png', 32, 8 );


		// Audio

		// this.loadAudio( 'crash' );
		// this.loadAudio( 'weeeeee' );
		// this.loadAudio( 'countdown' );
		// this.loadAudio( 'jump-land' );
		// this.loadAudio( 'lose' );
		// this.loadAudio( 'ski-turn' );
		// this.loadAudio( 'splash' );
		// this.loadAudio( 'win' );
		// this.loadAudio( 'wind' );
		// this.loadAudio( 'theme' );
		// this.loadAudio( 'menu' );

		// Physics

		Phaser.Physics.Arcade.sortDirection = Phaser.Physics.Arcade.TOP_BOTTOM;

		// Load player data.
		//
		// TODO: Move this somewhere better.
		// Game.Utils.PlayerProperties.init();

	},

	create: function() {

		// Game.Utils.PalletSwap.swap( 'palette', 'player' );

		// Initialize stuff.
		// Game.Utils.Audio.init();
		Game.Utils.Controls.init();

		game.state.start( 'menu' );

	},


	loadAudio: function( file ) {

		var mp3 = 'audio/' + file + '.mp3';
		var ogg = 'audio/' + file + '.ogg';

		game.load.audio( file, [ mp3, ogg ] );

	}

};

/* global Phaser, game */

Game.States.Menu = {

	/**
	 * Create menu
	 */
	create: function() {

		game.sound.stopAll();

		var logo = game.add.sprite( game.width / 2, game.height / 2, 'intro' );
		logo.anchor.setTo( 0.5, 0.5 );

		// Start the game when the screen is tapped
		game.input.onDown.addOnce( this.start, this );

		game.camera.flash( 0xffffff, 1000 );

		// Game.Utils.Audio.fade_in( 'menu', 1500, true );

	},

	/**
	 * Method to call on game start.
	 */
	start: function() {

		window.focus();

		game.state.start(
			'load-world',
			true,
			false,
			{
				type: 'world',
				path: 'world'
			}
		);

	}

};

/**
 * Overworld
 *
 * @type {Object}
 */
Game.States.World = {

	debug_tile: {},

	debug_player: {},

	player: null,

	map: null,

	params: null,


	/**
	 * Initialize the state.
	 *
	 * @param  {Object} params A json object storing the level parameters.
	 * @return {[type]}        [description]
	 */
	init: function( params ) {

		if ( params ) {

			this.params = params;

		}

	},


	/**
	 * Create game world
	 */
	create: function() {

		// game.renderer.renderSession.roundPixels = true; // Round pixels for the renderer
		// Phaser.Canvas.setImageRenderingCrisp( game.canvas ); // Set image rendering to be crisp (no antialiasing)
		// Phaser.Canvas.setSmoothingEnabled( game.context, false ); // Set the context to not smooth images
		// Phaser.Stage.scaleMode = Phaser.StageScaleMode.SHOW_ALL; // Ensure the scale mode shows all content

		// Stop all sounds
		game.sound.stopAll();

		// Create drawing layers.
		this.layers = Game.Utils.Layers.init();

		Game.Utils.Signposts.init( this.layers );

		Game.Utils.Hud.init( this.layers );

		// Create player
		this.player = new Game.Prefabs.Player( game, 0, 0, this.layers.groupElements );

		// Background sound effect.
		Game.Utils.Audio.play_loop( 'wind' );

		// load level
		if ( 'room' === this.params.type ) {
			Game.Utils.Map.load_room( this.params.slug, this.layers, this.params );
		} else {
			Game.Utils.Map.load_world( this.params.slug, this.layers, this.params );
		}

		Game.Utils.ManageWorld.init( this.layers );

		this.player.x = Game.Utils.Map.player_position.x;
		this.player.y = Game.Utils.Map.player_position.y;
		this.player.bringToTop();

		if ( Game.debug ) {

			this.debug_tile = new Phaser.Rectangle( 0, 0, Game.Utils.Map.TILE_SIZE, Game.Utils.Map.TILE_SIZE );
			this.debug_player = new Phaser.Rectangle( 0, 0, 2, 2 );

		}

		// Setup the game camera.
		Game.Utils.Camera.set_target( this.player );

		game.camera.roundPx = true;

		this.start_game();

	},


	/**
	 * Update game
	 */
	update: function() {

		if ( 'play' === Game.game_state ) {

		}

		// Update game properties.
		Game.Utils.ManageWorld.update( this.player );

	},


	/**
	 * Start the race and set all relevant variables.
	 */
	start_game: function() {

		// Game.Utils.Audio.play_loop( 'theme' );

		game.camera.focusOn( this.player );

		game.camera.flash( Game.background_color, 700 );

	},


	/**
	 * Apply render time effects.
	 */
	render: function() {

		// Do all the debug things.
		if ( Game.debug ) {

			this.debug_player.x = this.player.x - 1;
			this.debug_player.y = this.player.y - 1;

			// console.log( 'player', this.player.x, this.player.y );

			Game.Utils.Map.debug_zones();

			game.debug.body( this.player );

			var zone = game.camera.deadzone;
			game.context.fillStyle = 'rgba(255,0,0,0.6)';
			game.context.fillRect( zone.x, zone.y, zone.width, zone.height );

		}

	},

	preRender: function() {

		Game.Utils.ManageWorld.pre_render( this.player );

	},

};




// Last file to execute everything.

var game_size = get_game_size();
// var game = new Phaser.Game( game_size.width, game_size.height, Phaser.CANVAS, 'game-canvas', null, false, false );

// console.log( Phaser.CANVAS );

var game = new Phaser.Game(
	{
		width: game_size.width,
		height: game_size.height,
		renderer: Phaser.CANVAS,
		parent: 'game-canvas',
		antialias: false,
		roundPixels: true,
		crisp: true,
	}
);

// Define states
game.state.add( 'boot', Game.States.Boot );
game.state.add( 'load', Game.States.Load );
game.state.add( 'load-world', Game.States.LoadWorld );
game.state.add( 'menu', Game.States.Menu );
game.state.add( 'world', Game.States.World );

// Start the "boot" state
game.state.start( 'boot' );

